module.exports = __webpack_public_path__ + "static/media/logo.079c97a5.png";